import { render, staticRenderFns } from "./StatusesForm.vue?vue&type=template&id=d47eab1e&"
import script from "./StatusesForm.vue?vue&type=script&lang=js&"
export * from "./StatusesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports